var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "div",
        { staticClass: "fixed-top", attrs: { id: "app-header" } },
        [_c("sad-navbar")],
        1
      ),
      _vm._v(" "),
      _c("sad-navigation"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid content" },
        [
          _c("div", { staticClass: "px-5 pt-2 mb-5" }, [_c("router-view")], 1),
          _vm._v(" "),
          _c(
            "b-modal",
            { attrs: { id: "login-page", "hide-footer": "", lazy: "" } },
            [
              _c(
                "span",
                {
                  attrs: {
                    slot: "modal-title",
                    "data-cy": "loginTitle",
                    id: "login-title",
                  },
                  domProps: { textContent: _vm._s(_vm.$t("login.title")) },
                  slot: "modal-title",
                },
                [_vm._v("Sign in")]
              ),
              _vm._v(" "),
              _c("login-form"),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "footer" }, [
      _c("div", { staticClass: "footer-bottom" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-8" }, [
              _c("section", { staticClass: "region region-footer-bottom" }, [
                _c(
                  "nav",
                  {
                    attrs: {
                      role: "navigation",
                      "aria-labelledby": "block-menupieddepagefonce-menu",
                      id: "block-menupieddepagefonce",
                    },
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "visually-hidden",
                        attrs: { id: "block-menupieddepagefonce-menu" },
                      },
                      [_vm._v("Menu pied de page foncé")]
                    ),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.ge.ch/conditions-generales",
                            },
                          },
                          [_vm._v("Conditions générales")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.ge.ch/conditions-generales#translation",
                            },
                          },
                          [_vm._v("Traduction")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          { attrs: { href: "https://ge.ch/annuaire/" } },
                          [_vm._v("Annuaire")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("a", { attrs: { href: "https://intranet.ge.ch" } }, [
                          _vm._v("Intranet Etat"),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c("span", { staticClass: "footer-logo" }, [
                _vm._v(" GE.CH – République et canton de Genève "),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }